export default "__VITE_ASSET__DcJMy3mf__"